import Component from 'react-pure-render/component';
import CountListField from 'portaltransparencia-common/components/CountListField.react.js';
import NumberFormatter from 'portaltransparencia-common/components/NumberFormatter.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import PropTypes from 'prop-types';
import React from 'react';
import SumListField from 'portaltransparencia-common/components/SumListField.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';

export class AditivoDetalheItens extends Component {
  static propTypes = {
    aditivo: PropTypes.object.isRequired,
    isIntegradoOxy: PropTypes.bool.isRequired,
    uf: PropTypes.string.isRequired
  };

  isRealinhamento = () => {
    const { aditivo, isIntegradoOxy, uf } = this.props;
    const tipoAditivo = aditivo.get('tipoAditivoTce');
    const operacao = aditivo.get('tipoOperacaoTce');

    if (isIntegradoOxy) {
      return operacao === '1';
    }

    if (uf === 'RO' && tipoAditivo === '6') {
      return operacao === '1';
    }

    if (uf === 'PR' && tipoAditivo === '6') {
      return operacao === '3';
    }

    return tipoAditivo === '4' && (operacao === '1' || operacao === '3');
  };

  renderItens = data => {
    const isRealinhamento = this.isRealinhamento();
    const itemKey =
      data.get('entidade') +
      '_' +
      data.get('exercicio') +
      '_' +
      data.get('numero') +
      '_' +
      data.get('lote') +
      '_' +
      data.get('ordem');
    return (
      <TableActions ref="row" key={itemKey} data={data}>
        <td id="lote">{data.get('lote')}</td>
        <td id="ordem">{data.get('ordem')}</td>
        <td id="descricao">{data.get('descricao')}</td>
        <td id="unidade">{data.get('unidade')}</td>
        {isRealinhamento ? (
          <>
            <td id="valor" className="right">
              <NumberFormatter value={data.get('valor')} format="0,0.0000" />
            </td>
            <td id="valorAnterior" className="right">
              <NumberFormatter
                value={data.get('valorAnterior')}
                format="0,0.0000"
              />
            </td>
          </>
        ) : (
          <>
            <td id="quantidade" className="right">
              <NumberFormatter
                value={data.get('quantidade')}
                format="0,0.0000"
              />
            </td>
            <td id="valor" className="right">
              <NumberFormatter value={data.get('valor')} format="0,0.0000" />
            </td>
            <td id="valorTotal" className="right">
              <NumberFormatter
                value={data.get('valorTotal')}
                format="0,0.0000"
              />
            </td>
          </>
        )}
      </TableActions>
    );
  };

  render() {
    const itens = this.props.aditivo?.get('itens');
    const isRealinhamento = this.isRealinhamento();

    return (
      <div className="panel-table-outer">
        <Panel
          title="Itens Aditivados"
          expansible={false}
          isTable
          tableResponsive
        >
          <table className="panel-table striped fancy">
            <TableHeader empty={itens?.isEmpty()}>
              <tr>
                <th>Lote</th>
                <th>Ordem</th>
                <th>Descrição</th>
                <th>Unidade</th>
                {isRealinhamento ? (
                  <>
                    <th className="right">Valor Novo</th>
                    <th className="right">Valor Anterior</th>
                  </>
                ) : (
                  <>
                    <th className="right">Quantidade</th>
                    <th className="right">Valor Unitário</th>
                    <th className="right">Valor Total</th>
                  </>
                )}
              </tr>
            </TableHeader>
            <tbody>{itens?.map(this.renderItens)}</tbody>

            {itens && !itens.isEmpty() && (
              <tfoot>
                <tr>
                  <td colSpan={2}>
                    <i>Lotes: </i>
                    {<CountListField fieldName="lote" list={itens} />}
                  </td>
                  <td>
                    <i>Itens: </i>
                    {<CountListField list={itens} />}
                  </td>
                  <td></td>
                  {isRealinhamento ? (
                    <>
                      <td className="right">
                        <i>Total: </i>
                        {
                          <SumListField
                            fieldName="valor"
                            list={itens}
                            format="0,0.0000"
                          />
                        }
                      </td>
                      <td className="right">
                        <i>Total: </i>
                        {
                          <SumListField
                            fieldName="valorAnterior"
                            list={itens}
                            format="0,0.0000"
                          />
                        }
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="right">
                        <i>Total: </i>
                        {
                          <SumListField
                            fieldName="quantidade"
                            list={itens}
                            format="0,0.0000"
                          />
                        }
                      </td>

                      <td className="right">
                        <i>Total: </i>
                        {
                          <SumListField
                            fieldName="valor"
                            list={itens}
                            format="0,0.0000"
                          />
                        }
                      </td>
                      <td className="right">
                        <i>Total: </i>
                        {
                          <SumListField
                            fieldName="valor"
                            list={itens}
                            format="0,0.0000"
                          />
                        }
                      </td>
                      <td></td>
                    </>
                  )}
                </tr>
              </tfoot>
            )}
          </table>
        </Panel>
      </div>
    );
  }
}

export default AditivoDetalheItens;
